<script>
export default {
  name: "profile"
};
</script>

<template>
  <div class="view" id="profile">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <sapp-back />
            <span class="bar__title">Perfil</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
